import { makeStyles } from 'tss-react/mui';
import colors from 'themes/colors';

const styles = makeStyles()((theme) => ({
  LeftInfo: {
    backgroundColor: '#fff',

    '& .text-secondary': {
      color: '#5a5a5a',
      fontWeight: 600,
    },
  },
  Main: {},
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(4, 0),

    '& span': {
      color: '#8d8d8d',
    },
  },
  paper: {
    padding: theme.spacing(3, 4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',

    '& h4': {
      fontWeight: 'bold',
      fontSize: 22,
    },
  },
  Info: {
    padding: theme.spacing(2),
    margin: theme.spacing(0, 4),
    color: '#5a5a5a',
    fontWeight: 600,
    borderRadius: 5,
    backgroundColor: '#f6f6f6',
    marginTop: 25,

    '& h5': {
      fontWeight: 'bold',
      fontSize: 20,
    },

    '& div': {
      lineHeight: '30px',
    },

    '& .info-header': {
      display: 'flex',
      justifyContent: 'space-between',

      '& button': {
        boxShadow: 'none',
      },
    },
    '& button': {
      marginLeft: 15,
    },
    '& button span': {
      textTransform: 'initial',
    },
  },
  InfoLabel: {
    color: '#9b9b9b;',
    fontWeight: 500,
  },

  InfoRow: {
    padding: theme.spacing(1, 0),
  },

  DeleteBtn: {
    backgroundColor: '#c82f42 !important',

    '& span': {
      color: '#ffffff !important',
    },
  },

  Table: {
    marginTop: 20,
    display: 'block',
    overflowY: 'none',

    '& thead': {
      backgroundColor: theme.palette.secondary.main,
      display: 'table',
      width: '100%',
      tableLayout: 'fixed',

      '& th': {
        color: '#fff',
      },
    },
  },
  TableBody: {
    backgroundColor: '#fefefe',
    display: 'block',
    maxHeight: 400,
    overflowY: 'scroll',
    '& tr': {
      display: 'table',
      width: '100%',
      tableLayout: 'fixed',
    },
  },

  Remove: {
    backgroundColor: '#fff',
  },
  tableSortLabel: {
    '&:hover': {
      color: colors.white,
    },
    '&:focus': {
      color: colors.white,
    },
    '&.Mui-active': {
      color: colors.white,
      fontWeight: 'bold',

      '& .MuiTableSortLabel-icon': {
        color: `${colors.white} !important`,
      },
    },
  },
}));

export default styles;
